import React, { useState } from 'react';
import './ContactTestimonials.css';

const testimonials = [
  {
    name: 'Fanevasoa RAFANORENANTSOA',
    role: 'Software & Automation Developer',
    initials: 'FR',
    avatarBg: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    relation: 'Worked together',
    linkedin: 'https://www.linkedin.com/in/faneva-sarobidy-rafanorenantsoa-138172211/',
    quote:
      "I had the pleasure of working with Fenofifaliana. I was impressed by his ability to manage teams and his work's quality. One instance that stands out is when he worked as a Webflow integrator — this showed not only his technical expertise but also his leadership, teamwork, and creativity. Beyond his professional skills, Fenofifaliana is collaborative and inspiring, which makes working with him a real pleasure. I confidently recommend him to any team looking for great teamwork.",
  },
  {
    name: 'Faniry RAKOTOARISON',
    role: 'HR | Responsable de site',
    initials: 'FR',
    avatarBg: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
    relation: 'Direct colleague',
    linkedin: 'https://www.linkedin.com/in/faniry-rakotoarison-868ab8371/',
    quote:
      "J'ai eu l'occasion de collaborer avec Fenofifaliana RAFANOMEZANTSOA, qui a travaillé comme intégrateur web, et je peux confirmer la qualité de son travail. Il a toujours fait preuve de professionnalisme, de rigueur et d'efficacité dans l'exécution de ses missions. Son sens du détail, sa maîtrise technique et son engagement ont largement contribué à la réussite des projets auxquels il a participé.",
  },
  {
    name: 'Jim Medlock',
    role: 'Co-Founder, Chingu Inc.',
    initials: 'JM',
    avatarBg: 'linear-gradient(135deg, #d66022 0%, #f59e0b 100%)',
    relation: 'Mentor at Chingu',
    linkedin: 'https://www.linkedin.com/in/jdmedlock/',
    quote:
      "As a member of Chingu, Fenofifaliana has distinguished himself as an active participant and a mentor to other developers. He has successfully completed both a Solo Project and one of our 6-week remote team projects. He is a great example of a lifelong learner who never stops adding to his knowledge base — and more importantly, he openly shares what he has learned to help others.",
  },
];

function TestiCard({ name, role, initials, avatarBg, relation, linkedin, quote }) {
  return (
    <article className="testi-card">
      <a href={linkedin} target="_blank" rel="noreferrer"><span className="li-badge">in</span></a>

      <div className="testi-author-row">
        <div className="testi-avatar-wrap">
          <div className="testi-avatar-ring">
            <div className="testi-avatar" style={{ background: avatarBg }}>
              {initials}
            </div>
          </div>
          <span className="online-dot" aria-hidden="true" />
        </div>

        <div className="testi-author-info">
          {linkedin ? (
            <a
              className="testi-name"
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              {name} ↗
            </a>
          ) : (
            <span className="testi-name">{name}</span>
          )}
          <p className="testi-role">{role}</p>
        </div>
      </div>

      <div className="testi-relation">{relation}</div>

      <blockquote>{quote}</blockquote>

      <div className="testi-stars">
        {'★★★★★'.split('').map((s, i) => <span key={i}>{s}</span>)}
      </div>
    </article>
  );
}

export default function ContactTestimonials() {
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    try {
      await fetch('https://formsubmit.co/ajax/fullfifax14@gmail.com', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      form.reset();
      setShowModal(true);
      setTimeout(() => setShowModal(false), 4000);
    } catch (err) {
      console.error('Form submission error:', err);
    }
  };

  return (
    <section className="contact-testi-section" id="contacts">
      <div className="grain" aria-hidden="true" />

      <div className="contact-testi-inner">

        {/* ── LEFT: Testimonials ── */}
        <div className="testi-col">
          <div className="ct-header">
            <div className="section-label">Testimonials</div>
            <h2>People I've Worked With</h2>
          </div>

          <div className="testi-list">
            {testimonials.map((t, i) => (
              <TestiCard key={i} {...t} />
            ))}
          </div>
        </div>

        {/* ── RIGHT: Contact form ── */}
        <div className="contact-col">
          <div className="ct-header">
            <div className="section-label">Contact</div>
            <h2>Get in Touch</h2>
          </div>

          <div className="contact-card">
            <form onSubmit={handleSubmit} className="contact-form">
              <input type="text"   name="_honey"   style={{ display: 'none' }} />
              <input type="hidden" name="_captcha" value="false" />

              <input type="text"  name="name"    placeholder="Your Name"    required />
              <input type="email" name="email"   placeholder="Your Email"   required />
              <textarea           name="message" placeholder="Your Message" required />
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" role="dialog" aria-modal="true">
          <div className="modal-content">
            <button className="modal-close" onClick={() => setShowModal(false)} aria-label="Close">×</button>
            <h3>Message Sent!</h3>
            <p>Thank you for reaching out. I'll get back to you soon!</p>
          </div>
        </div>
      )}
    </section>
  );
}